<template>
  <div class="mrg-t-10 app-container" id="printContent">
    <navBar :title="'报价单'" @handleGoBack="handleGoBack">
    </navBar>
<!--    <div slot="footer" class="dialog-footer mrg-t-10" v-if="showBtn">
      <van-button ref="btn" type="primary" v-print="printObj" @click="handlePrint">预 览 PDF</van-button>
    </div>-->
    <van-row class="mrg-t-10">
      <van-col span="4">
        <img src="https://file.yimixiuxiu.com/group1/M00/00/3B/Cs4AD2aHSReAXp0oAABkspJwcPc895.png" style="width: 40px">
      </van-col>
      <div class="mrg-t-11" style="font-size: 18px;font-weight: bold">{{ printForm.title }}</div>
      <div class="mrg-t-7" style="font-size: 14px">{{ printForm.titleEng }}</div>
    </van-row>
    <van-row class="mrg-t-8">
      <van-col span="10">
        <img src="https://file.yimixiuxiu.com/group1/M00/00/3B/Cs4AD2aHSPuAKrfpAADGd2du28M324.jpg" style="width: 80px">
      </van-col>
      <van-col span="9">
        <img src="https://file.yimixiuxiu.com/group1/M00/00/3C/Cs4AD2aYx6KAOyQQAACvAcVt2eE370.png" style="width: 80px">
      </van-col>
      <van-col span="5">
        <img src="https://file.yimixiuxiu.com/group1/M00/00/3B/Cs4AD2aHSPuAQ7vUAABtlu-IJYw155.jpg" style="width: 80px;margin-top: -10px">
      </van-col>
    </van-row>
    <div style="text-align: center;font-weight: bold;font-size: 16px">报 价 单（QUOTATION）</div>
    <van-form>
      <van-row>
        <van-col span="12">
          <van-field
              v-model="printForm.name"
              label="客户方:"
              name="name"
          />
<!--          <el-form-item label="客户方:" prop="name">
            <template v-if="isEdit">
              <el-input v-model="printForm.name" placeholder="请输入"/>
            </template>
            <template v-else>
              <div>{{ printForm.name }}</div>
            </template>
          </el-form-item>-->
        </van-col>
        <van-col span="12">
          <van-field
              v-model="printForm.companyName"
              label="供货方:"
              name="companyName"
          />
<!--          <el-form-item label="供货方:" prop="companyName">
            <template v-if="isEdit">
              <el-input v-model="printForm.companyName" placeholder="请输入"/>
            </template>
            <template v-else>
              <div>{{ printForm.companyName }}</div>
            </template>
          </el-form-item>-->
        </van-col>
        <van-col span="12">
          <van-field
              v-model="printForm.name2"
              label="单位名称:"
              name="name2"
          />
<!--          <el-form-item label="单位名称:" prop="name2">
            <template v-if="isEdit">
              <el-input v-model="printForm.name2" placeholder="请输入"/>
            </template>
            <template v-else>
              <div>{{ printForm.name2 }}</div>
            </template>
          </el-form-item>-->
        </van-col>
        <van-col span="12">
          <van-field
              v-model="printForm.companyName2"
              label="单位名称:"
              name="companyName2"
          />
<!--          <el-form-item label="单位名称:" prop="companyName2">
            <template v-if="isEdit">
              <el-input v-model="printForm.companyName2" placeholder="请输入"/>
            </template>
            <template v-else>
              <div>{{ printForm.companyName2 }}</div>
            </template>
          </el-form-item>-->
        </van-col>
        <van-col span="12">
          <van-field
              v-model="printForm.address"
              label="地址:"
              name="address"
          />
<!--          <el-form-item label="地址:" prop="address">
            <template v-if="isEdit">
              <el-input v-model="printForm.address" placeholder="请输入"/>
            </template>
            <template v-else>
              <div>{{ printForm.address }}</div>
            </template>
          </el-form-item>-->
        </van-col>
        <van-col span="12">
          <van-field
              v-model="printForm.companyAddress"
              label="地址:"
              name="companyAddress"
          />
<!--          <el-form-item label="地址:" prop="companyAddress">
            <template v-if="isEdit">
              <el-input v-model="printForm.companyAddress" placeholder="请输入"/>
            </template>
            <template v-else>
              <div>{{ printForm.companyAddress }}</div>
            </template>
          </el-form-item>-->
        </van-col>
        <van-col span="12">
          <van-field
              v-model="printForm.phone"
              label="电话:"
              name="phone"
          />
<!--          <el-form-item label="电话:" prop="phone">
            <template v-if="isEdit">
              <el-input v-model="printForm.phone" placeholder="请输入"/>
            </template>
            <template v-else>
              <div>{{ printForm.phone }}</div>
            </template>
          </el-form-item>-->
        </van-col>
        <van-col span="12">
          <van-field
              v-model="printForm.companyPhone"
              label="电话:"
              name="companyPhone"
          />
<!--          <el-form-item label="电话:" prop="companyPhone">
            <template v-if="isEdit">
              <el-input v-model="printForm.companyPhone" placeholder="请输入"/>
            </template>
            <template v-else>
              <div>{{ printForm.companyPhone }}</div>
            </template>
          </el-form-item>-->
        </van-col>
        <van-col span="12">
          <van-field
              v-model="printForm.fax"
              label="传真:"
              name="fax"
          />
<!--          <el-form-item label="传真:" prop="fax">
            <template v-if="isEdit">
              <el-input v-model="printForm.fax" placeholder="请输入"/>
            </template>
            <template v-else>
              <div>{{ printForm.fax }}</div>
            </template>
          </el-form-item>-->
        </van-col>
        <van-col span="12">
          <van-field
              v-model="printForm.companyFax"
              label="传真:"
              name="companyFax"
          />
<!--          <el-form-item label="传真:" prop="companyFax">
            <template v-if="isEdit">
              <el-input v-model="printForm.companyFax" placeholder="请输入"/>
            </template>
            <template v-else>
              <div>{{ printForm.companyFax }}</div>
            </template>
          </el-form-item>-->
        </van-col>
        <van-col span="12">
          <van-field
              v-model="printForm.contactsName"
              label="联系人:"
              name="contactsName"
          />
<!--          <el-form-item label="联系人:" prop="contactsName">
            <template v-if="isEdit">
              <el-input v-model="printForm.contactsName" placeholder="请输入"/>
            </template>
            <template v-else>
              <div>{{ printForm.contactsName }}</div>
            </template>
          </el-form-item>-->
        </van-col>
        <van-col span="12">
          <van-field
              v-model="printForm.companyContactsName"
              label="联系人:"
              name="companyContactsName"
          />
<!--          <el-form-item label="联系人:" prop="companyContactsName">
            <template v-if="isEdit">
              <el-input v-model="printForm.companyContactsName" placeholder="请输入"/>
            </template>
            <template v-else>
              <div>{{ printForm.companyContactsName }}</div>
            </template>
          </el-form-item>-->
        </van-col>
      </van-row>
    </van-form>

    <table style="width: 100%" border="0" cellspacing="0">
      <thead>
      <tr style="font-size: 12px">
        <td>序号</td>
        <td>名称</td>
        <td>型号</td>
        <td>参考单价(含税)</td>
        <td>数量</td>
        <td>图片</td>
        <td>品牌</td>
        <td>备注</td>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(item,index) in printForm.productList" :key="item.id" style="font-size: 12px">
        <td>
          <div>{{ index+1 }}</div>
        </td>
        <td>
          <van-field v-model="item.materialName" />
<!--          <template v-if="isEdit">
            <el-input v-model="item.materialName" style="width: 100px"/>
          </template>
          <template v-else>
            <div>{{ item.materialName }}</div>
          </template>-->
        </td>
        <td>
          <van-field v-model="item.materialSpecification" />
<!--          <template v-if="isEdit">
            <el-input v-model="item.materialSpecification" style="width: 100px"/>
          </template>
          <template v-else>
            <div>{{ item.materialSpecification }}</div>
          </template>-->
        </td>
        <td>
          <van-field v-model="item.price" />
<!--          <template v-if="isEdit">
            <el-input v-model="item.price" style="width: 100px"/>
          </template>
          <template v-else>
            <div>{{ item.price }}</div>
          </template>-->
        </td>
        <td>
          <van-field v-model="item.quantity" />
<!--          <template v-if="isEdit">
            <el-input v-model="item.quantity" style="width: 100px"/>
          </template>
          <template v-else>
            <div>{{ item.quantity }}</div>
          </template>-->
        </td>
        <td>
          <img :src="item.annexUrl" style="width: 80px">
        </td>
        <td>
          <van-field v-model="item.materialBrand" />
<!--          <template v-if="isEdit">
            <el-input v-model="item.materialBrand" style="width: 100px"/>
          </template>
          <template v-else>
            <div>{{ item.materialBrand }}</div>
          </template>-->
        </td>
        <td>
          <van-field v-model="item.remark" />
<!--          <template v-if="isEdit">
            <el-input v-model="item.remark" style="width: 100px"/>
          </template>
          <template v-else>
            <div>{{ item.remark }}</div>
          </template>-->
        </td>
      </tr>
      <tr>
        <td style="font-size: 10px">
          备注:
        </td>
        <td :colspan="7">
          <van-field v-model="printForm.remark" />
          <!--template v-if="isEdit">
            <el-input type="textarea" :rows="3" v-model="printForm.remark"/>
          </template>
          <template v-else>
            <div v-html="printForm.remark" style="text-align: left"></div>
          </template>-->
        </td>
      </tr>
      </tbody>
    </table>
    <van-row class="mrg-t-10" style="font-size: 10px">
      <van-col span="16">
        <div style="margin-left: 75%">供应商签章</div>
      </van-col>
      <van-col span="8">
        <img src="https://file.yimixiuxiu.com/group1/M00/00/3B/Cs4AD2aHaYGAcVpNAAICs1N78w8551.png" style="width: 120px" class="chapter">
      </van-col>
    </van-row>
  </div>
</template>
<script>
import { fetchProductList } from '@/api/crm/bussiness'
import { getDetailByCustomerId } from '@/api/crm/customer'

export default {
  data() {
    return {
      printObj: {
        id: 'printContent',
        popTitle: '报价单',
        extraCss: '',
        extraHead: '<meta http-equiv="Content-Language" content="zh-cn"/>'
      },
      printForm: {},
      queryParams: {},
      isEdit: true,
      showBtn: true,
      customerId: null,
    }
  },

  created() {
    this.queryParams.id = this.$route.query.id
    this.customerId = this.$route.query.customerId
    //查询客户信息
    this.findCustomerMsg()
  },

  methods: {
    handleGoBack() {
      this.$router.replace('/crm/cost/detail?id='+this.queryParams.id);
      this.$router.go(-1)
    },

    //查询客户信息
    async findCustomerMsg() {
      let result = await getDetailByCustomerId({
        customerId: this.customerId
      })
      this.printForm = result.data

      //查询产品列表
      await this.getProductList()

      this.$set(this.printForm, 'title', '北 京 锦 绣 前 程 玻 璃 有 限 公 司')
      this.$set(this.printForm, 'titleEng', 'BEIJING GLORIOUS FUTURE GLASS CO.,LTD')
      this.$set(this.printForm, 'companyName', '北京锦绣前程玻璃有限公司')
      this.$set(this.printForm, 'name2', this.printForm.name)
      this.$set(this.printForm, 'companyName2', '北京锦绣前程玻璃有限公司')

      let address = ''
      if(this.printForm.address){
        address = this.printForm.address.replaceAll(',','')
      }
      if(this.printForm.addressDetail){
        address += this.printForm.addressDetail
      }
      this.$set(this.printForm, 'address', address)

      this.$set(this.printForm, 'companyAddress', '北京市北京经济技术开发区荣京东街3号1幢14层2单元1217')
      this.$set(this.printForm, 'companyPhone', '0317-5281151')
      this.$set(this.printForm, 'fax', '')
      this.$set(this.printForm, 'companyFax', '')
      this.$set(this.printForm, 'companyContactsName', '')
      this.$set(this.printForm, 'remark', '1.以上报价含13%增值税。\n' +
          '2.预付款，收到贵司货款后，安排发货。\n' +
          '3.报价单一星期有效，因成本增加或降低导致价位变动，恕不另行通知。')
    },

    //查询产品列表
    async getProductList() {
      this.loading = true
      let result = await fetchProductList(this.queryParams)

      let totalPrice = 0
      let totalNum = 0
      let productList = result.data
      productList.forEach(item=>{
        totalPrice = totalPrice+(Number(item.price)*Number(item.quantity))
        totalNum = totalNum+Number(item.quantity)
      })
      productList.push({
        materialName: '合计',
        materialSpecification: '',
        price: totalPrice,
        quantity: totalNum,
        annexUrl: '',
        materialBrand: '',
        remark: ''
      })

      this.$set(this.printForm, 'productList', productList)
    },

    handlePrint() {
      this.printForm.remark = this.printForm.remark.replaceAll('\n','<br />')
      this.showBtn = false
      this.isEdit = false
      setTimeout(() => {
        this.printForm.remark = this.printForm.remark.replaceAll('<br />','\n')
        this.showBtn = true
        this.isEdit = true
      }, 2000)
    }
  }
}
</script>
<style lang="scss" scoped>
table {
  border-collapse: separate;
  border-top: 1px solid #000000;
  border-left: 1px solid #000000;
}
thead tr td {
  background-color: #f8f8f9;
  padding: 6px;
  text-align: center;
  border-bottom: 1px solid #000000;
  border-right: 1px solid #000000;
}
tbody tr td {
  padding: 6px;
  text-align: center;
  height: 34px;//设置单元格最小高度
  border-bottom: 1px solid #000000;
  border-right: 1px solid #000000;
}

.chapter{
  position: relative;
  top: -50px;
}

::v-deep .el-form-item__label{
  color: black;
}

::v-deep .van-field__control{
  font-size: 12px;
}

@page {
  margin: 5px 10px 0px 10px;
}
</style>
